<template>
  <div></div>
</template>

<script>

export default {
  name: 'Recovery',
  props: ['id'],
  created() {
    this.$router.push({ name: 'home' });
    this.$modal.show('modal-recovery-password', {key: this.id});
  },
};
</script>